// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module__wrapper___25lCK"};